export enum FlowTags {
  Cx = 'cx',
  Forest = 'forest',
  IncidentManagement = 'incident-management',
  PaymentFailed = 'payment-failed',
  PaymentScheduled = 'payment-scheduled',
  Pops = 'pops',
  Refund = 'refund',
  Risk = 'risk',
  SelfServe = 'self-serve',
  Test = 'test',
  Tools = 'tools',
  Chatbot = 'chatbot',
  ExcludeFromChatbotPotentialPayments = 'exclude-from-chatbot-potential-payments'
}

const optionConfigs: Record<FlowTags, { disabled?: boolean }> = {
  [FlowTags.Cx]: {},
  [FlowTags.Forest]: {},
  [FlowTags.IncidentManagement]: {},
  [FlowTags.PaymentFailed]: {},
  [FlowTags.PaymentScheduled]: {},
  [FlowTags.Pops]: {},
  [FlowTags.Refund]: {},
  [FlowTags.Risk]: {},
  [FlowTags.SelfServe]: {},
  [FlowTags.Test]: {},
  [FlowTags.Tools]: {},
  [FlowTags.Chatbot]: {},
  [FlowTags.ExcludeFromChatbotPotentialPayments]: {}
};

export const flowTagsOptions = Object.entries(optionConfigs).map(
  ([value, config]) => ({
    ...config,
    // to keep predefined and user-provided values consistent
    label: value,
    value
  })
);
